<template>
  <BaseListItem>
    <div class="flex -mx-4 py-2">
      <div class="w-24 px-4">
        <RouterLink :to="toAccount">
          <template v-if="cover">
            <img
              v-if="cover"
              :srcset="cover.srcsets || ''"
              @load.once="onImageLoad"
              sizes="1px"
              :src="cover.url"
              class="block rounded w-full"
            />
          </template>
          <template v-else>
            <div class="aspect-ratio-16/9 w-full rounded bg-gray-200" />
          </template>
        </RouterLink>
      </div>
      <div class="flex-1 px-4">
        <RouterLink :to="toAccount">
          {{ provider.name }}
        </RouterLink>
      </div>
      <div class="w-32 px-4 text-right">
        <span class="font-medium">{{ serviceProvider.cost }}</span> &euro;
      </div>
      <div class="w-32 px-2 text-right">
        <BaseDropdown alignment="right" use="BaseLinkButton" :custom-classes="{}">
          <template>
            <FontAwesomeIcon icon="ellipsis-v" fixed-width />
          </template>
          <template #menu="dropdownProps">
            <BaseList nested>
              <BaseListBody>
                <BaseListItem
                  v-if="$hasPermissionTo('edit products')"
                  actionable
                  @click="edit() || dropdownProps.close()"
                >
                  Edit...
                </BaseListItem>
                <BaseListItem
                  v-if="$hasPermissionTo('edit products')"
                  actionable
                  @click="destroy() || dropdownProps.close()"
                >
                  Delete...
                </BaseListItem>
              </BaseListBody>
            </BaseList>
          </template>
        </BaseDropdown>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
import { mapState } from 'vuex';
import mediableMixin from '@/mixins/mediableMixin';

const defaultServiceProvider = {
  serviceUuid: null,
  providerUuid: null,
  cost: 0,
};

export default {
  name: 'ListItem',

  mixins: [mediableMixin],

  props: {
    entity: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('entities', {
      accountsById: (state) => state.accounts.byId,
    }),

    serviceProvider() {
      return { ...defaultServiceProvider, ...this.entity };
    },

    provider() {
      if (!this.serviceProvider.providerUuid) {
        return null;
      }

      return this.accountsById[this.serviceProvider.providerUuid] || null;
    },

    cover() {
      const { media = [] } = this.provider || {};

      return media.length ? media[0] : null;
    },

    toAccount() {
      const { providerUuid = null } = this.serviceProvider || {};

      return {
        name: 'accounts.show',
        params: {
          accountId: providerUuid,
        },
      };
    },
  },

  methods: {
    edit() {
      this.$emit('edit', this.entity);
    },

    destroy() {
      this.$emit('destroy', this.entity);
    },
  },
};
</script>
